import React from 'react';

const formatSelectedProductsLabel = (count) => {
  const n10 = count % 10;
  const n100 = count % 100;
  if (n10 === 1 && n100 !== 11) return `${count} товар`;
  if (n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14)) return `${count} товари`;
  return `${count} товарів`;
};

const SelectedOrderItemsDropdown = ({
  selectedCount,
  show,
  onToggleShow,
  onCloseDropdown,
  onOpenBulkDiscount,
  onOpenBulkDiscountForAll,
  onMoveSelected,
  onSplitSelected,
  onExportExcel,
  onExportInvoice,
  onClearSelection,
  alignRight = false,
  compact = false,
}) => {
  const hasSelection = selectedCount > 0;
  const buttonLabel = hasSelection
    ? `Дії. Обрано ${formatSelectedProductsLabel(selectedCount)}`
    : 'Дії';

  return (
    <div className="dropdown d-inline-block position-relative ml-1">
      <button
        type="button"
        className={`btn btn-dark btn-sm dropdown-toggle d-inline-flex align-items-center flex-shrink-0 border-0${compact ? '' : ' font-weight-bold shadow-sm'}`}
        onClick={() => onToggleShow(!show)}
        aria-label={buttonLabel}
        aria-expanded={Boolean(show)}
        style={{ borderRadius: compact ? '5px' : '8px', padding: compact ? '0.25rem 0.65rem' : '0.35rem 0.85rem', fontSize: compact ? '0.75rem' : '0.875rem' }}
      >
        {compact ? 'Дії' : buttonLabel}
      </button>
      {show && (
        <>
          <div
            className="position-fixed"
            style={{ inset: 0, zIndex: 1040 }}
            onClick={onCloseDropdown}
            aria-hidden="true"
          />
          <div className="dropdown-menu show position-absolute" style={{ zIndex: 1050, minWidth: '14rem', ...(alignRight ? { left: 'auto', right: 0 } : {}) }}>
            {hasSelection ? (
              <>
                <button
                  type="button"
                  className="dropdown-item d-flex align-items-center"
                  onClick={() => {
                    onCloseDropdown();
                    onOpenBulkDiscount();
                  }}
                >
                  <i className="bi bi-percent mr-2" style={{ width: '1.25rem' }} />
                  Встановити знижку
                </button>
                <button
                  type="button"
                  className="dropdown-item d-flex align-items-center"
                  onClick={() => {
                    onCloseDropdown();
                    onExportExcel();
                  }}
                >
                  <i className="bi bi-file-earmark-excel mr-2" style={{ width: '1.25rem' }} />
                  Сформувати ексель
                </button>
                {onExportInvoice && (
                  <button
                    type="button"
                    className="dropdown-item d-flex align-items-center"
                    onClick={() => {
                      onCloseDropdown();
                      onExportInvoice();
                    }}
                  >
                    <i className="bi bi-receipt mr-2" style={{ width: '1.25rem' }} />
                    Сформувати рахунок
                  </button>
                )}
                <div className="dropdown-divider" />
                {onMoveSelected && (
                  <button type='button' className='dropdown-item d-flex align-items-center'
                    onClick={() => { onCloseDropdown(); onMoveSelected(); }}>
                    <i className='bi bi-arrow-left-right mr-2' style={{ width: '1.25rem' }} />
                    Перенести в інше замовлення
                  </button>
                )}
                {onSplitSelected && (
                  <button type='button' className='dropdown-item d-flex align-items-center'
                    onClick={() => { onCloseDropdown(); onSplitSelected(); }}>
                    <i className='bi bi-box-arrow-up-right mr-2' style={{ width: '1.25rem' }} />
                    Виділити в окреме замовлення
                  </button>
                )}
                <div className="dropdown-divider" />
                <button
                  type="button"
                  className="dropdown-item d-flex align-items-center"
                  onClick={() => {
                    onCloseDropdown();
                    onClearSelection();
                  }}
                >
                  <i className="bi bi-x-circle mr-2" style={{ width: '1.25rem' }} />
                  Зняти вибір
                </button>
              </>
            ) : (
              <>
                <button
                  type="button"
                  className="dropdown-item d-flex align-items-center"
                  onClick={() => {
                    onCloseDropdown();
                    onOpenBulkDiscountForAll();
                  }}
                >
                  <i className="bi bi-percent mr-2" style={{ width: '1.25rem' }} />
                  Встановити знижку для всіх
                </button>
                <button
                  type="button"
                  className="dropdown-item d-flex align-items-center"
                  onClick={() => {
                    onCloseDropdown();
                    onExportExcel();
                  }}
                >
                  <i className="bi bi-file-earmark-excel mr-2" style={{ width: '1.25rem' }} />
                  Сформувати ексель файл
                </button>
                {onExportInvoice && (
                  <button
                    type="button"
                    className="dropdown-item d-flex align-items-center"
                    onClick={() => {
                      onCloseDropdown();
                      onExportInvoice();
                    }}
                  >
                    <i className="bi bi-receipt mr-2" style={{ width: '1.25rem' }} />
                    Сформувати рахунок на оплату
                  </button>
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SelectedOrderItemsDropdown;
